import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Calendar } from "lucide-react";
import { useLocation } from "react-router-dom";

export function MobileStickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling down 400px
      if (window.scrollY > 400) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Hide on booking page or dashboard
  if (location.pathname.includes("/book") || location.pathname.includes("/dashboard")) {
    return null;
  }

  const isReturning = typeof window !== 'undefined' ? (parseInt(localStorage.getItem("site_visits") || "0") > 1) : false;

  return (
    <div 
      className={`md:hidden fixed bottom-0 left-0 right-0 p-4 bg-background/95 backdrop-blur-md border-t border-border z-50 transition-transform duration-300 ease-in-out ${
        isVisible ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <Button asChild size="lg" className="w-full text-lg font-bold h-14 bg-primary text-primary-foreground shadow-lg">
        <a href="/book?view=custom-plan" aria-label="Get instant price from sticky banner">
          <Calendar className="mr-2 h-5 w-5" />
          {isReturning ? "Book Again" : "Get Instant Price"}
        </a>
      </Button>
    </div>
  );
}
